import { tb } from '#/store/translation/translation.store';

const webOnlyKey = 'web.iap.description';
const allPlatformsKey = 'iap.description';

/** This could be replaced with i18next.t(['web.iap.description', 'iap.description']) feature,
 *  but i18next default configuration treats empty strings as valid translations.
 *  In our case "web.iap.description" key is always present, but its value may be an empty string
 *  ,so it will never fall back to "iap.description". This is the reason why we have this
 *  method here. Other solution would be to set returnEmptyString: false in i18next init
 *  config, but it may have negative impact on whole application. **/
const getTranslation = (keys: string[]) => {
  for (const key of keys) {
    const result = tb(key);

    if (result && result !== key) {
      return result;
    }
  }

  return null;
};

export const getDisclaimer = () => {
  const keys = [webOnlyKey, allPlatformsKey];

  return getTranslation(keys);
};
